module.exports = __webpack_public_path__ + "img/p1_bg.5c3f9f05.jpg";